import { Inject, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { IContainmentType, InsectaServiceBase } from '../';
import { isEmpty } from '../../../common/functions';
import { DictionaryCacheService } from '../dictionary-cache.service';
import { HttpClient } from '@angular/common/http';
import { SETTINGS, Settings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class ContainmentTypeAdminService extends InsectaServiceBase {
  constructor(
    private http: HttpClient,
    @Inject(SETTINGS) settings: Settings,
    private dictionaryCache: DictionaryCacheService
  ) {
    super(http, settings);
  }
  public addContainmentType(containmenttype: IContainmentType): Observable<string> {
    return this.post<string>(`/admin/containmenttypes`, `v1`, {
      name: containmenttype.name,
      isActive: containmenttype.isActive,
      username: containmenttype.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('containmenttype')));
  }

  public getContainmentType(id: string): Observable<IContainmentType> {
    return this.get<IContainmentType>(`/admin/containmenttypes/${id}`, 'v1');
  }

  public getContainmentTypes(includeInActive: boolean | null | undefined): Observable<IContainmentType[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<IContainmentType[]>(`/admin/containmenttypes`, 'v1').pipe(
      map((results) => [...results].filter((x: IContainmentType) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: IContainmentType, b: IContainmentType) =>
          a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive < b.isActive ? 1 : -1
        )
      )
    );
  }

  public getContainmentTypeAll(): Observable<IContainmentType[]> {
    return this.getContainmentTypes(true);
  }

  public updateContainmentType(containmenttype: IContainmentType): Observable<any> {
    return this.put<IContainmentType>(`/admin/containmenttypes/${containmenttype.id}`, `v1`, {
      id: containmenttype.id,
      name: containmenttype.name,
      isActive: containmenttype.isActive,
      username: containmenttype.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('containmenttype')));
  }
}
